import { useEffect, useState } from "react"
import { obterParametrosGerais, salvarParametro } from "../../../services/parametros"
import useAppStore from "../../../stores/AppStore"

// Mesma regra de ImpressaoStore.ts: só usa o layout novo quando o parâmetro
// existir e vier explicitamente "true"/"1" — sem o parâmetro cadastrado, o
// padrão é o layout antigo.
function ehLayoutNovo(valor: string) {
    return valor === "true" || valor === "1"
}

export function useImpressaoNova() {
    const idEstabelecimento = useAppStore(
        s => s.configuracoes?.user?.parametros?.estabelecimento?.id
    )
    const [usarImpressaoNova, setUsarImpressaoNova] = useState(false)
    const [idParametro, setIdParametro] = useState<string | number | null>(null)
    const [carregando, setCarregando] = useState(false)

    useEffect(() => {
        const carregarParametroImpressaoNova = async () => {
            const autorizacao = localStorage.getItem("chaveSistema")
            if (!autorizacao || !idEstabelecimento) return
            try {
                const response = await obterParametrosGerais(idEstabelecimento, autorizacao)
                if (!response?.retornoErro) {
                    const parametro = (response || []).find(
                        (p: any) => p.nome === "PUBLIC_IMPRESSAO_NOVA"
                    )
                    if (parametro) {
                        setIdParametro(parametro.id)
                        setUsarImpressaoNova(ehLayoutNovo(parametro.valor))
                    }
                }
            } catch {
                // mantém o padrão (layout antigo) se não conseguir carregar o parâmetro
            }
        }
        carregarParametroImpressaoNova()
    }, [idEstabelecimento])

    const alterarImpressaoNova = async (usarNovo: boolean) => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao || !idEstabelecimento) return
        setCarregando(true)
        try {
            const dados: { id?: string | number; nome: string; valor: string; publico: boolean } = {
                nome: "PUBLIC_IMPRESSAO_NOVA",
                valor: usarNovo ? "true" : "false",
                publico: true,
            }
            if (idParametro) dados.id = idParametro

            const response = await salvarParametro(idEstabelecimento, dados, autorizacao)
            if (response?.retornoErro) {
                throw new Error(response.mensagem || "Erro ao salvar layout de impressão.")
            }

            setUsarImpressaoNova(usarNovo)
            if (response?.id) setIdParametro(response.id)

            const customParams = JSON.parse(localStorage.getItem("custom-params") ?? "{}")
            customParams.PUBLIC_IMPRESSAO_NOVA = usarNovo
            localStorage.setItem("custom-params", JSON.stringify(customParams))
        } finally {
            setCarregando(false)
        }
    }

    return { usarImpressaoNova, carregandoImpressaoNova: carregando, alterarImpressaoNova }
}
